import { faChevronDown, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Card, Dropdown } from 'react-bootstrap';
import Button from 'components/base/Button';
import classNames from 'classnames';
import { useAppContext } from 'providers/AppProvider';
import MediaWidgetAddMediaObject from './MediaWidgetAddMediaObject';
import { useMediaWidgetContext } from 'providers/MediaWidgetProvider';
//import MediaWidgetFooter from './MediaWidgetFooter';
import PropTypes from 'prop-types';
import { TextString, Shape, Background, Slide } from 'data/konva';

interface MediaWidgetProps {
  slideActiveId: string;
  onAddSlide: (newSlide: Slide) => void;
  onRemoveSlide: (delSlideIndex: Slide) => void;
  onAddTextString: (newTextString: TextString) => void;
  onAddShape: (newShape: Shape) => void;
  onAddImage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAddBackground: (newBackground: Background) => void;
  //onRemoveBackground: (delBackgroundIndex: ImageItem) => void;
  onClearSlide: () => void;
  onResetAll: () => void;
}

const MediaWidget: React.FC<MediaWidgetProps> = ({
  slideActiveId,
  onAddSlide,
  onRemoveSlide,
  onAddTextString,
  onAddShape,
  onAddImage,
  onAddBackground,
  //onRemoveBackground,
  onClearSlide,
  onResetAll
}) => {
  const {
    config: { isMediaWidgetVisible }
  } = useAppContext();
  const { isOpenMedia, setIsOpenMedia } = useMediaWidgetContext();

  return (
    <div
      className={classNames({
        'd-none': !isMediaWidgetVisible
      })}
    >
      <div
        className={classNames('container-fluid support-media', {
          'show-media': isOpenMedia
        })}
      >
        <Card className="bg-white media">
          <Card.Header className="d-flex flex-between-center px-4 py-2 border-bottom">
            <h5 className="mb-0 d-flex align-items-center gap-2">
              Add media
              {/* <FontAwesomeIcon icon={faCircle} className="text-success fs-11" /> */}
            </h5>
            <RevealDropdownTrigger>
              <RevealDropdown>
                <Dropdown.Item>Upload media</Dropdown.Item>
                <Dropdown.Item>Report a problem</Dropdown.Item>
                <Dropdown.Item onClick={() => setIsOpenMedia(!isOpenMedia)}>
                  Exit
                </Dropdown.Item>
              </RevealDropdown>
            </RevealDropdownTrigger>
          </Card.Header>
          <Card.Body className="scrollbar p-3">
            <MediaWidgetAddMediaObject
              slideActiveId={slideActiveId}
              onAddSlide={onAddSlide}
              onRemoveSlide={onRemoveSlide}
              onAddTextString={onAddTextString}
              onAddShape={onAddShape}
              onAddImage={onAddImage}
              onAddBackground={onAddBackground}
              onClearSlide={onClearSlide}
              onResetAll={onResetAll}
            />
          </Card.Body>
        </Card>
      </div>
      <Button
        className={classNames('p-0 border border-200 btn-support-media', {
          'btn-media-close': isOpenMedia
        })}
        onClick={() => setIsOpenMedia(!isOpenMedia)}
      >
        <FontAwesomeIcon icon={faPlus} className="text-success fs-7" />
        <FontAwesomeIcon icon={faChevronDown} className="text-success fs-7" />
      </Button>
    </div>
  );
};
MediaWidget.propTypes = {
  slideActiveId: PropTypes.string.isRequired,
  onAddSlide: PropTypes.func.isRequired,
  onRemoveSlide: PropTypes.func.isRequired,
  onAddTextString: PropTypes.func.isRequired,
  onAddShape: PropTypes.func.isRequired,
  onAddImage: PropTypes.func.isRequired,
  onAddBackground: PropTypes.func.isRequired,
  onClearSlide: PropTypes.func.isRequired,
  onResetAll: PropTypes.func.isRequired
};
export default MediaWidget;
